import { render, staticRenderFns } from "./TabelOphthalmicDisabled.vue?vue&type=template&id=2908e02d&"
import script from "./TabelOphthalmicDisabled.vue?vue&type=script&lang=js&"
export * from "./TabelOphthalmicDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports